import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { LodashService } from '../../shared/services/lodash.service';

@Injectable({
  providedIn: 'root',
})
export class ElevationService {
  private baseUrl = environment.nestElevationApiUrl;
  constructor(
    private http: HttpClient, // private errorHandlerService: ErrorHandlerService
    private efoLd: LodashService,
  ) {}

  getData(
    url,
    data?,
    headers:
      | string
      | {
          [name: string]: string | string[];
        }
      | any = {},
  ): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    return this.http.get(`${this.baseUrl}${url}${qStr}`, {
      headers: new HttpHeaders(headers),
    });
  }

  postData(url, body = {}, data?): Observable<any> {
    const qStr = data
      ? '?' +
        _.map(data, (d, k) => {
          return `${k}=${d}`;
        }).join('&')
      : '';
    return this.http.post(`${this.baseUrl}${url}${qStr}`, body);
  }

  fauxboxServiceResults(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.http.get(`${this.baseUrl}/fauxbox/serviceResults?${params}`);
  }
  fauxboxSalesResults(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.http.get(`${this.baseUrl}/fauxbox/salesResults?${params}`);
  }
  fauxboxRrmReport(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.http.get(`${this.baseUrl}/fauxbox/rrmReport?${params}`);
  }
  getFauxboxCustomer(fauxbox_key: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/getFauxboxCustomer?fauxbox_key=${fauxbox_key}`,
    );
  }
  getRrmReportHtml(fauxbox_key: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/getRrmReportHtml?fauxbox_key=${fauxbox_key}`,
    );
  }
  targetRefreshesByCampaignKey(options): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/targetRefreshesByCampaignKey?account_num=${options.account_num}&campaign_key=${options.campaign_key}`,
    );
  }
  getOmtSummaryReport(gvars?): Observable<any> {
    const params = _.map({ ...gvars }, (d, k) => {
      return `${k}=${d}`;
    }).join('&');
    return this.http.get(
      `${this.baseUrl}/fauxbox/getOmtSummaryReport?${params}`,
    );
  }
  getSalesCalendar(account_num, campaign_key): Observable<any> {
    return this.http
      .get(
        `${this.baseUrl}/fauxbox/getSalesCalendar?account_num=${account_num}&campaign_key=${campaign_key}`,
      )
      .pipe(
        map((rs: any) => {
          _.each(rs, (d) => {
            d.mm = moment(d.m, 'M').format('MM');
          });
          return {
            salesCalendarData: rs,
            // @ts-ignore
            salesCalendarDataByYearMonth: this.efoLd.groupByMulti(rs, [
              'y',
              'mm',
            ]),
          };
        }),
      );
  }
  getEmailBodyFilesByAccount(account_num, date): Promise<any> {
    return this.http
      .get(
        `${this.baseUrl}/robomail/emailBodyFilesByAccount?account_num=${account_num}&date=${date}`,
      )
      .toPromise();
  }

  getAdsByAccountAndDate(account_num, date): Promise<any> {
    return this.http
      .get(
        `${this.baseUrl}/facebook/getAdsByAccountAndDate?account_num=${account_num}&date=${date}`,
      )
      .toPromise();
  }

  getMatchingTypeReport(campaign_key?): Observable<any> {
    const pvars = campaign_key ? { campaign_key: campaign_key } : {};
    return this.http.get(
      `${this.baseUrl}/matching/getMatchingTypeReport?campaign_key=${campaign_key}`,
    );
  }

  getDmsSalesByCustNum(account_num, cust_num, campaign_key): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/matching/sales/getDmsSalesByCustNum?account_num=${account_num}&cust_num=${cust_num}&campaign_key=${campaign_key}`,
    );
  }
  getDmsServiceByCustNum(account_num, cust_num, campaign_key): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/matching/service/getDmsServiceByCustNum?account_num=${account_num}&cust_num=${cust_num}&campaign_key=${campaign_key}`,
    );
  }
  getDmsSalesByVin(account_num, vin): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/matching/sales/getDmsSalesByVin?account_num=${account_num}&vin=${vin}`,
    );
  }
  getDmsServiceByVin(account_num, vin): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/matching/service/getDmsServiceByVin?account_num=${account_num}&vin=${vin}`,
    );
  }
  getMatchesByMatchType(
    account_num,
    campaign_key,
    match_type,
    start_date,
    end_date,
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/getMatchesByMatchType?account_num=${account_num}&campaign_key=${campaign_key}&match_type=${match_type}&start_date=${start_date}&end_date=${end_date}`,
    );
  }
  getMatchesByVehicleType(
    account_num,
    campaign_key,
    vehicle_type,
    start_date,
    end_date,
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/getMatchesByVehicleType?account_num=${account_num}&campaign_key=${campaign_key}&vehicle_type=${vehicle_type}&start_date=${start_date}&end_date=${end_date}`,
    );
  }
  getPureConquest(
    account_num,
    campaign_key,
    start_date,
    end_date,
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/fauxbox/getPureConquest?account_num=${account_num}&campaign_key=${campaign_key}&start_date=${start_date}&end_date=${end_date}`,
    );
  }

  checkFauxboxAccess(fauxbox_key: string, admin_key?: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/access/checkFauxboxAccess?fauxbox_key=${fauxbox_key}&admin_key=${admin_key}`,
    );
  }
}
